import { IMAGE_SIZE } from '@api/media/constants';
import * as utils from '@utils/form';

export const FORM_FIELD = {
  ATHLETE_IMAGE: {
    name: 'primaryMedia',
    label: 'Primary media:',
    size: IMAGE_SIZE['2000x714'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
    deserializeError: utils.deserializeErrorRelatedField,
  },
  TWITTER: {
    name: 'twitterUsername',
    label: 'Twitter Username:',
    placeholder: 'Username without @ For example”worldathletics” for @worldathletics',
  },
  INSTAGRAM: {
    name: 'instagramUsername',
    label: 'Instagram ID:',
    placeholder: 'You may obtain your User ID here',
  },
  FACEBOOK: {
    name: 'facebookUsername',
    label: 'Facebook ID:',
    placeholder: 'You may obtain your User ID here',
  },
};

export const FORM_FIELDS = Object.values(FORM_FIELD);

export const DEFAULT_VALUES = {};
